import { load } from '@shopify/theme-sections';
import accordion from '@/components/accordion';
import stickyHeader from '@/components/stickyHeader';
import headerOverlay from '@/components/headerOverlay';
import drawerOverlay from '@/components/drawerOverlay';
import cartDrawer from '@/components/cartDrawer';
import modal from '@/components/modal';
import quickAdd from '@/lib/quick-add';
import storeAvailabilityDrawer from '@/components/storeAvailabilityDrawer';
import { fetchCart } from '@/neon/cart.js';
import { hydrate } from '@/neon/events';

// Import all theme styles
// import '../styles/theme.css';

// Initialize lazysizes
import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/rias/ls.rias';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';

// Import sections
import '@/sections';

// Load all sections
document.addEventListener('DOMContentLoaded', () => {
  load('*');

  // Get cart state before initializing quick cart
  fetchCart().then(cart => {
    hydrate({ cart });

    // Setup cart drawer
    const cartDrawerElement = document.querySelector('[data-cart-drawer]');
    cartDrawer(cartDrawerElement);
  });
});

// Make it easy to see exactly what theme version
// this is by commit SHA
// window.SHA = SHA;

// Detect theme editor
if (Shopify.designMode === true) {
  document.documentElement.classList.add('theme-editor');
} else {
  const el = document.querySelector('.theme-editor-scroll-offset');
  el && el.remove();
}

// Handle all accordion shortcodes
const accordions = document.querySelectorAll('.accordion');

if (accordions.length) {
  accordions.forEach(item => {
    accordion(item);
  });
}

// Setup sticky header
const headerWrapper = document.querySelector('.header-container');
stickyHeader(headerWrapper);

// Setup header overlay
const headerOverlayContainer = document.querySelector('[data-header-overlay]');
headerOverlay(headerOverlayContainer);

// Setup drawer overlay
const drawerOverlayContainer = document.querySelector('[data-drawer-overlay]');
drawerOverlay(drawerOverlayContainer);

// Setup modal
const modalElement = document.querySelector('[data-modal]');
modal(modalElement);

// Quick add to cart
quickAdd();

// Prdocut availabilty drawer
const availabilityDrawer = document.querySelector(
  '[data-store-availability-drawer]'
);
storeAvailabilityDrawer(availabilityDrawer);

// Determine if the user is a mouse or keyboard user
function handleFirstTab(e) {
  if (e.keyCode === 9) {
    document.body.classList.add('user-is-tabbing');

    window.removeEventListener('keydown', handleFirstTab);
    window.addEventListener('mousedown', handleMouseDownOnce);
  }
}

function handleMouseDownOnce() {
  document.body.classList.remove('user-is-tabbing');

  window.removeEventListener('mousedown', handleMouseDownOnce);
  window.addEventListener('keydown', handleFirstTab);
}

window.addEventListener('keydown', handleFirstTab);

// Disable auto zoom on input field for ios devices.
// https://stackoverflow.com/a/57527009
const addMaximumScaleToMetaViewport = () => {
  const el = document.querySelector('meta[name=viewport]');

  if (el !== null) {
    let content = el.getAttribute('content');
    let re = /maximum\-scale=[0-9\.]+/g;

    if (re.test(content)) {
      content = content.replace(re, 'maximum-scale=1.0');
    } else {
      content = [content, 'maximum-scale=1.0'].join(', ');
    }

    el.setAttribute('content', content);
  }
};

const disableIosTextFieldZoom = addMaximumScaleToMetaViewport;

// https://stackoverflow.com/questions/9038625/detect-if-device-is-ios/9039885#9039885
const checkIsIOS = () =>
  /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

if (checkIsIOS()) {
  disableIosTextFieldZoom();
}

// Wrap all tables
const tables = document.querySelectorAll('table');

tables.forEach(el => {
  const wrapper = document.createElement('div');
  wrapper.classList.add('rte-table');
  wrapper.tabIndex = 0;

  el.parentNode.insertBefore(wrapper, el);

  wrapper.appendChild(el);
});

// Focus errors
const errorEl = document.querySelector('.form-status__message--error');

if (errorEl) {
  errorEl.focus();

  document.title = 'Error - ' + document.title;
}

// Make it easy to see exactly what theme version
// this is by commit SHA
window.SHA = '__gitSHA';
